import React, { Fragment } from 'react';
import TenantAuditReportView from './TenantAuditReportView';

// Thin route entry — the V3 shell lives inside the view.
const TenantAuditReport = () => (
    <Fragment>
        <TenantAuditReportView />
    </Fragment>
);

export default TenantAuditReport;
